import { render } from "./WebChatButton.vue?vue&type=template&id=17253858"
import script from "./WebChatButton.vue?vue&type=script&lang=js"
export * from "./WebChatButton.vue?vue&type=script&lang=js"

import "./WebChatButton.vue?vue&type=style&index=0&id=17253858&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__